import LayoutMaster from "../../components/layout/layout_master";
import BackBlog from "components/view/back_blog";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import ViewAllBlog from "components/view/view_all_blog";
import get_all_blogs, {
  GetAllBlogsResponse,
} from "lib/worker/api/get_all_blogs";

interface Props {
  infomation: CheckWithPrefixResponse;
  blogs: GetAllBlogsResponse[];
}

function AllBlog(props: Props) {
  const { blogs } = props;

  return (
    <LayoutMaster
      content_setting={{
        title: "บทความ",
        description:
          "เทคนิคและวิธีการเล่นต่างๆ ที่จะช่วยให้การเดิมพันของท่านง่ายขึ้น",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <BackBlog></BackBlog>
        <ViewAllBlog blogs={blogs}></ViewAllBlog>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  try {
    const blogs = await get_all_blogs({ prefix: infomation.prefix });
    return {
      props: {
        infomation: infomation,
        blogs: blogs,
      },
    };
  } catch (error) {
    return {
      props: {
        infomation: infomation,
        blogs: [],
      },
    };
  }
};

export default AllBlog;
